import { render } from "./UserDetailPaper.vue?vue&type=template&id=b6d8cc4a&scoped=true"
import script from "./UserDetailPaper.vue?vue&type=script&lang=js"
export * from "./UserDetailPaper.vue?vue&type=script&lang=js"

import "./UserDetailPaper.vue?vue&type=style&index=0&id=b6d8cc4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6d8cc4a"]])

export default __exports__